import apiClient from "../client";

// Get tenant ID from localStorage or context
const getTenantId = () => {
  return localStorage.getItem("tenantId") || sessionStorage.getItem("tenantId");
};

// Get company settings
export const getCompanySettings = async () => {
  try {
    const tenantId = getTenantId();
    const response = await apiClient.get("/company-settings", {
      headers: {
        "X-Tenant-Id": tenantId,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching company settings:", error);
    throw error;
  }
};

// Regular report endpoints (these use authentication middleware)
export const getSalesReport = (fromDate, toDate) => {
  const params = new URLSearchParams({
    fromDate: fromDate,
    toDate: toDate,
  });
  return apiClient.get(`/reports/sales?${params.toString()}`);
};

// Stock Report
export const getStockReport = () => {
  return apiClient.get(`/reports/stock`);
};

// GST Report endpoints (NEW)
export const getGSTReport = (fromDate, toDate) => {
  const params = new URLSearchParams({
    fromDate: fromDate,
    toDate: toDate,
  });
  return apiClient.get(`/reports/gst?${params.toString()}`);
};

// Get Financial Report
export const getFinancialReport = (fromDate, toDate) => {
  const params = new URLSearchParams({
    fromDate: fromDate,
    toDate: toDate,
  });
  return apiClient.get(`/reports/financial?${params.toString()}`);
};

// Get Customer Report (using query parameters)
export const getCustomerReport = (customerId, fromDate, toDate) => {
  const params = new URLSearchParams({
    fromDate: fromDate,
    toDate: toDate,
    customerId: customerId,
  });
  return apiClient.get(`/reports/customer?${params.toString()}`);
};

// Get all customers (for dropdown)
export const getCustomers = async () => {
  const tenantId = getTenantId();
  return apiClient.get("/customers", {
    headers: {
      "X-Tenant-Id": tenantId,
    },
  });
};
// Get Expenses Report
export const getExpensesReport = (fromDate, toDate) => {
  const params = new URLSearchParams({
    fromDate: fromDate,
    toDate: toDate,
  });
  return apiClient.get(`/reports/expenses?${params.toString()}`);
};
// Export endpoints (need explicit tenant ID)
export const exportSalesReport = async (format, fromDate, toDate) => {
  console.log("=== exportSalesReport called ===");
  console.log("Format:", format);
  console.log("From Date:", fromDate);
  console.log("To Date:", toDate);

  const tenantId = getTenantId();
  console.log("Tenant ID:", tenantId);

  const params = new URLSearchParams({
    format: format,
    fromDate: fromDate,
    toDate: toDate,
    tenantId: tenantId,
  });

  const url = `/reports/export/sales?${params.toString()}`;
  console.log("Request URL:", url);

  const response = await apiClient.get(url, {
    responseType: "blob",
  });

  console.log("Response received, status:", response.status);
  console.log("Response headers:", response.headers);

  return response;
};

// Export GST Report (NEW)
export const exportGSTReport = async (format, fromDate, toDate) => {
  console.log("=== exportGSTReport called ===");
  console.log("Format:", format);
  console.log("From Date:", fromDate);
  console.log("To Date:", toDate);

  const tenantId = getTenantId();
  console.log("Tenant ID:", tenantId);

  const params = new URLSearchParams({
    format: format,
    fromDate: fromDate,
    toDate: toDate,
    tenantId: tenantId,
  });

  const url = `/reports/export/gst?${params.toString()}`;
  console.log("Request URL:", url);

  const response = await apiClient.get(url, {
    responseType: "blob",
  });

  console.log("Response received, status:", response.status);
  console.log("Response headers:", response.headers);

  return response;
};

// Export Financial Report
export const exportFinancialReport = async (format, fromDate, toDate) => {
  console.log("=== exportFinancialReport called ===");
  console.log("Format:", format);
  console.log("From Date:", fromDate);
  console.log("To Date:", toDate);

  const tenantId = getTenantId();
  console.log("Tenant ID:", tenantId);

  const params = new URLSearchParams({
    format: format,
    fromDate: fromDate,
    toDate: toDate,
    tenantId: tenantId,
  });

  const url = `/reports/export/financial?${params.toString()}`;
  console.log("Request URL:", url);

  const response = await apiClient.get(url, {
    responseType: "blob",
  });

  console.log("Response received, status:", response.status);
  return response;
};

// Export Expenses Report
export const exportExpensesReport = async (format, fromDate, toDate) => {
  console.log("=== exportExpensesReport called ===");
  console.log("Format:", format);
  console.log("From Date:", fromDate);
  console.log("To Date:", toDate);

  const tenantId = getTenantId();
  console.log("Tenant ID:", tenantId);

  const params = new URLSearchParams({
    format: format,
    fromDate: fromDate,
    toDate: toDate,
    tenantId: tenantId,
  });

  const url = `/reports/export/expenses?${params.toString()}`;
  console.log("Request URL:", url);

  const response = await apiClient.get(url, {
    responseType: "blob",
  });

  console.log("Response received, status:", response.status);
  return response;
};
// Export Customer Report (using query parameters)
export const exportCustomerReport = async (
  customerId,
  format,
  fromDate,
  toDate,
) => {
  const tenantId = getTenantId();
  const params = new URLSearchParams({
    format: format,
    fromDate: fromDate,
    toDate: toDate,
    customerId: customerId,
    tenantId: tenantId,
  });

  const response = await apiClient.get(
    `/reports/export/customer?${params.toString()}`,
    {
      responseType: "blob",
    },
  );

  return response;
};
